import GlobalFilterForm from "./GlobalFilterForm";

export default GlobalFilterForm;